import ReactECharts from "echarts-for-react";
import { AppCard } from "@/layout/AppComponents";

const Report25OnlineInfo = ({ responseData }) => {
  const getColorByValue = (data) => {
    const value = Number(data[4]);
    if (value >= 90) return "#006400";
    if (value >= 70) return "#90EE90";
    if (value >= 50) return "#FFD700";
    if (value >= 30) return "#FFA500";
    return "#FF0000";
  };

  const downloadChart = (chart) => {
    if (!chart) return;
    const url = chart.getDataURL({
      type: "png",
      pixelRatio: 2,
      backgroundColor: "#fff",
    });
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = "grafico.png"; // o `grafico-${index}.png` / título
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="row mt-3">
      <div className="col-12">
        {responseData?.onlineInfo?.map((c) => {
          let chartInstance = null;

          return (
            <AppCard className="mb-3">
              <button
                className="btn btn-sm btn-primary"
                onClick={() => downloadChart(chartInstance)}
              >
                Descargar como imagen
              </button>
              <div
                style={{
                  width: "80%",
                  height: "900px",
                  margin: "auto",
                }}
              >
                <ReactECharts
                  style={{ width: "100%", height: "100%" }}
                  onChartReady={(chart) => {
                    chartInstance = chart;
                    chart.resize();
                  }}
                  option={{
                    title: {
                      text: c[0]?.[5] ?? "",
                      left: "center",
                      top: 0,
                    },
                    grid: {
                      top: 60,
                      right: 300, // px; sube/baja según longitud de nombres
                    },
                    xAxis: {
                      type: "value",
                      name: "MI",
                      nameLocation: "middle",
                      splitLine: { show: false },
                      min: 0,
                      max: 100,
                    },
                    yAxis: {
                      type: "value",
                      name: "CI",
                      nameLocation: "middle",
                      splitLine: { show: false },
                      scale: true,
                      min: 0,
                      max: 100,
                    },
                    series: [
                      {
                        name: "1990",
                        data: c,
                        type: "scatter",
                        itemStyle: {
                          color: (params) => getColorByValue(params.data),
                        },
                        symbolSize: (data) => data[2],
                        emphasis: {
                          focus: "self",
                        },
                        // labelLayout: () => ({
                        //   x: chartRef.current?.getWidth() - 300,
                        //   moveOverlap: "shiftY",
                        // }),
                        label: {
                          show: true,
                          formatter: function (param) {
                            return param.data[3];
                          },
                          position: "right",
                          minMargin: 2,
                        },
                      },
                    ],
                  }}
                />
              </div>
            </AppCard>
          );
        })}
      </div>
    </div>
  );
};

export default Report25OnlineInfo;
